import { createAsyncThunk } from "@reduxjs/toolkit";
import { postEmailReport } from "../../helpers/fakebackend_helper";

export const shareEmailReportThunk = createAsyncThunk(
  "shareEmailReportThunk",
  async ({ body, token }, { rejectWithValue }) => {
    try {
      const response = await postEmailReport(body, token);
      return response;
    } catch (error) {
      // Properly pass the error structure to the reducer
      return rejectWithValue({
        code: error.data?.code || error.code,
        message: error.message,
        data: error.data,
      });
    }
  }
);
